module.exports = __webpack_public_path__ + "static/media/30.7197bb1f.png";